import { render } from "./TheA01GiftMeritPanel.vue?vue&type=template&id=79ba0096&scoped=true&ts=true"
import script from "./TheA01GiftMeritPanel.vue?vue&type=script&lang=ts"
export * from "./TheA01GiftMeritPanel.vue?vue&type=script&lang=ts"

import "./TheA01GiftMeritPanel.vue?vue&type=style&index=0&id=79ba0096&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79ba0096"]])

export default __exports__